import {
    Align,
    ChartDataset,
    Chart
  } from 'chart.js'

export const roundValue = (value: number, number: number, character: string): string => {
    const roundNumber = value / number
    if (String(Math.floor(roundNumber)).length === 3) {
        return roundNumber.toFixed(0) + character
    }
    return roundNumber.toFixed(1) + character
}
  
export const formatScientificNotation = (value: number): string => {
    if (value / 1000000000 > 1) {
        return roundValue(value, 1000000000, 'B')
    }
    if (value / 1000000 > 1) {
        return roundValue(value, 1000000, 'M')
    }
    if (value / 1000 > 10) {
        return roundValue(value, 1000, 'K')
    }
    return String(value)
}
  
export const dataLabelAlignment = (chart: Chart, dataIndex: number, dataset: ChartDataset, small: Align, large: Align, postfix: string): Align => {
    const current = dataset.data[dataIndex] as number
    const value = formatScientificNotation(current) + postfix
    const max = dataset.data[0] as number
    const percent = current / max
    const barPixels = (chart.width / 2) * percent
    const pixelsPerCharacter = barPixels / String(value).length
    if (pixelsPerCharacter < 12) {
      return small
    }
    return large
}
  
export const formatYTicks = function FormatYTicks(MAX_LABEL_CHARACTERS: number) {
    return function FormatAxisTicks(value: number): string {
        const label = this.getLabelForValue(value)
        if (label.length > MAX_LABEL_CHARACTERS) {
            return `${label.substring(0, MAX_LABEL_CHARACTERS - 3)  }...`
        }
        return String(label)
    }
}